// extracted by mini-css-extract-plugin
var _1 = "BestValueContainer_bestValueWrapper__rZZHQ";
export { _1 as "bestValueWrapper" }
